import { Component, Inject } from '@angular/core';
import { StateService } from "@uirouter/angular";
import { JobTitlesDataService } from "../../core/jobtitles.dataservice";
import { MatDialog } from "@angular/material/dialog";
import { DetailsBase } from "../shared/details.base";

@Component({
    selector: "crew-jobtitle",
    template: require('../shared/details-view.html')
})
export class JobTitle extends DetailsBase<Nema.Crew.Model.JobType> {
    constructor(
        stateService: StateService,
        dialog: MatDialog,
        @Inject('jobTitle') jobTitle: Nema.Crew.Model.JobType,
        @Inject(JobTitlesDataService.Id) jobTitleDataService: JobTitlesDataService,
        @Inject('$log') $log: ng.ILogService) {

        super(stateService, dialog, jobTitle, jobTitleDataService, $log);
    }

    public entityName = "Job Title";

    public editStateName = "app.settings.jobtitles.edit";

    public listStateName = "app.settings.jobtitles";
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobtitles/jobtitle.component.ts